import angular from 'angular'
import { EditTeamModalComponent } from './edit-team-modal.component';
import { TeamsListComponent } from './teams-list.component';
import { TeamLeaderDashboardComponent } from './team-leader-dashboard.component';

export const TeamModule = angular
    .module('apex.mainApp.team', [])
    .component("apexEditTeamModal", EditTeamModalComponent)
    .component("apexTeamsList", TeamsListComponent)
    .component("apexTeamLeaderDashboard", TeamLeaderDashboardComponent)
    .name
